import React from "react";

export const Logo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 533.83 103.58"
      {...props}
    >
      <path
        d="M514.67,34.38l-2.62,9.18-2.62-9.18c-1.38-4.82-5.15-8.59-9.97-9.97l-9.19-2.63,9.18-2.62c4.82-1.38,8.59-5.15,9.97-9.97l2.63-9.19,2.62,9.18c1.38,4.82,5.15,8.59,9.97,9.97l9.19,2.63-9.18,2.62c-4.82,1.38-8.59,5.15-9.97,9.97h0Z"
        stroke="#1C1C1C"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <g>
        <path
          d="M25.31,103.58c-4.73,0-9.25-.39-13.56-1.17-4.32-.78-8.23-1.91-11.75-3.4l1.88-14.24c4.3,1.84,8.52,3.23,12.66,4.19,4.14.96,8.05,1.44,11.72,1.44,4.69,0,8.23-.83,10.63-2.49,2.4-1.66,3.6-4.09,3.6-7.29,0-4.18-2.38-7.36-7.15-9.55l-12.95-6.15c-5.82-2.73-10.3-6.11-13.45-10.14-3.15-4.02-4.72-8.65-4.72-13.89,0-7.27,2.31-12.89,6.94-16.88s11.18-5.98,19.66-5.98c5.31,0,10.2.87,14.68,2.61,4.47,1.74,8.56,4.37,12.28,7.88l-9.67,10.66c-3.01-2.66-5.93-4.66-8.76-6.01-2.83-1.35-5.65-2.02-8.47-2.02-3.67,0-6.52.83-8.55,2.49-2.03,1.66-3.05,4.07-3.05,7.24,0,2.19.69,4.11,2.08,5.77,1.39,1.66,3.39,3.16,6.01,4.48l11.66,5.8c5.98,2.97,10.56,6.4,13.74,10.28,3.18,3.89,4.78,8.37,4.78,13.45,0,7.46-2.57,13.15-7.71,17.05-5.14,3.91-12.65,5.86-22.53,5.86Z"
          stroke="#1C1C1C"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path d="M66.13,102.41V14.52h14.47v87.89h-14.47ZM75.5,79.73v-13.48h7.03c4.84,0,8.83-.84,11.95-2.52,3.12-1.68,5.59-4.42,7.38-8.23,1.8-3.81,3.11-8.88,3.93-15.21h14.94c-1.64,13.24-5.38,23.12-11.22,29.65-5.84,6.52-13.86,9.79-24.05,9.79h-9.96ZM107.32,102.41l-16.23-30.23,13.18-4.8,20.45,35.04h-17.4Z" />
        <path
          d="M130.44,102.41v-13.12h24.43v13.12h-24.43ZM133.96,53.42v-13.12h34.16v13.12h-34.16ZM160.32,31.33c-2.77,0-5.06-.9-6.86-2.7-1.8-1.8-2.7-4.08-2.7-6.86s.9-5.06,2.7-6.86c1.8-1.8,4.08-2.7,6.86-2.7s5.06.9,6.86,2.7c1.8,1.8,2.7,4.08,2.7,6.86s-.9,5.06-2.7,6.86c-1.8,1.8-4.08,2.7-6.86,2.7ZM153.7,102.41v-58.59h14.41v58.59h-14.41ZM166.95,102.41v-13.12h19.86v13.12h-19.86Z"
          stroke="#1C1C1C"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M186.12,27.64v-13.12h32.29l-13.36,13.12h-18.93ZM225.38,103.58c-7.58,0-13.04-2.07-16.38-6.21-3.34-4.14-5.01-10.76-5.01-19.86V19.16l14.41-4.64v62.4c0,2.85.29,5.19.88,7s1.71,3.16,3.37,4.01c1.66.86,4.13,1.29,7.41,1.29s7.62-.74,12.77-2.23l1.64,14.12c-3.24.86-6.38,1.48-9.4,1.88-3.03.39-6.26.59-9.7.59Z"
          stroke="#1C1C1C"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M239.43,27.64v-13.12h32.29l-13.36,13.12h-18.93ZM278.69,103.58c-7.58,0-13.04-2.07-16.38-6.21-3.34-4.14-5.01-10.76-5.01-19.86V18.87l14.41-4.35v62.4c0,2.85.29,5.19.88,7s1.71,3.16,3.37,4.01c1.66.86,4.13,1.29,7.41,1.29s7.62-.74,12.77-2.23l1.64,14.12c-3.24.86-6.38,1.48-9.4,1.88-3.03.39-6.26.59-9.7.59Z"
          stroke="#1C1C1C"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M306.21,102.41V19.21h14.12v83.2h-14.12ZM308.67,67.49v-13.01h50.45v13.01h-50.45ZM347.16,102.41V19.21h14.12v83.2h-14.12Z"
          stroke="#1C1C1C"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M392.21,103.58c-6.13,0-10.89-1.94-14.27-5.83-3.38-3.89-5.07-9.37-5.07-16.44v-41.02h14.47v38.67c0,3.55.9,6.3,2.7,8.23,1.8,1.93,4.28,2.9,7.44,2.9,4.06,0,7.12-1.44,9.17-4.31s3.08-7.68,3.08-14.44l3.16,19.1h-4.51c-.98,4.22-2.88,7.46-5.71,9.73-2.83,2.26-6.32,3.4-10.46,3.4ZM409.73,84.83v-44.53h14.47v41.02l-14.47,3.52ZM410.78,103l-1.05-14.88v-10.9h14.47v12.19l8.55,1.29v11.72l-21.97.59Z"
          stroke="#1C1C1C"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M439.18,102.41V14.52h14.47v86.84l-14.47,1.05ZM456.41,103.58c-2.89,0-5.75-.11-8.58-.32-2.83-.21-5.71-.5-8.64-.85l5.39-14c2.07.98,4.36,1.55,6.86,1.73,2.5.18,4.98.26,7.44.26,6.91,0,12.25-2.01,16.03-6.04,3.77-4.02,5.65-9.73,5.65-17.11,0-4.77-1.08-8.45-3.25-11.04-2.17-2.6-5.26-3.9-9.29-3.9-9.57,0-14.36,5.06-14.36,15.18l-3.63-15.94h5.1c.86-8.28,5.84-12.42,14.94-12.42,8.01,0,14.2,2.44,18.57,7.32,4.37,4.88,6.56,11.82,6.56,20.8,0,11.52-3.38,20.46-10.14,26.81-6.76,6.35-16.31,9.52-28.65,9.52Z"
          stroke="#1C1C1C"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
};
